import Axios from 'axios';
import config from '../../../config';

export const gatewayFetcher = Axios.create({
  baseURL: config.gateway.url,
});
